import { Injectable } from '@angular/core';
import {
  GridController,
  TSortDirections,
} from 'src/app/shared/classes/grid-page-info';
import { FilterItems } from 'src/app/shared/components/filters/filter.interface';
import {
  GroupEnrollmentFilters,
  IGroupEnrollment,
} from 'src/app/shared/interfaces/group-enrollment/group-enrollment.interface';

@Injectable({
  providedIn: 'root',
})
export class GroupEnrollmentStateService extends GridController<GroupEnrollmentFilters> {
  private _groupEnrollment: IGroupEnrollment[];

  private _filter: GroupEnrollmentFilters = {
    enrollmentStatus: [],
    id: '',
    npi: '',
    taxId: '',
    payerName: '', // payer.name
    payerId: '',
    caseNumber: '',
    enrollmentType: '',
    showLast: '',
    dateFrom: '',
    dateTo: '',
    enrollmentOwner: '',
  };

  groupEnrollmentFilters: FilterItems = {
    filtersName: 'groupEnrollments',
    items: [
      {
        name: 'enrollmentStatus',
        caption: 'Agreement Status',
        type: 'ngselect',
        bindLabel: 'text',
        bindValue: 'value',
        placeholder: 'Select Status',
        multiple: true,
        withCheckbox: true,
        class: 'enrollmentStatus',
        values: [
          { text: 'Sent to Customer', value: 'C' },
          { text: 'Approved', value: 'A' },
          { text: 'Submitted', value: 'S' },
          { text: 'To be sent', value: 'P' },
          { text: 'Denied', value: 'D' },
          { text: 'Inactive', value: 'I' },
          { text: 'Not applicable', value: 'N' },
          { text: 'Manual action required', value: 'M' },
          { text: 'ERA approval received', value: 'W' },
          { text: 'Automated setup failed', value: 'F' },
        ],
      },
      {
        name: 'id',
        caption: 'Group ID',
        type: 'text',
        placeholder: 'Enter Group ID',
        disabled: false,
        class: 'groupId',
      },
      {
        name: 'npi',
        caption: 'NPI',
        type: 'text',
        placeholder: 'Enter NPI',
        class: 'npi',
      },
      {
        name: 'taxId',
        caption: 'Tax ID',
        type: 'text',
        placeholder: 'Enter Tax ID',
        class: 'taxId',
      },
      {
        name: 'payerName',
        caption: 'Payer Name',
        type: 'text',
        placeholder: 'Enter Payer Name',
        class: 'payer',
      },
      {
        name: 'payerId',
        caption: 'payer id',
        type: 'text',
        placeholder: 'Enter Payer ID',
        class: 'payerId',
      },
      {
        name: 'caseNumber',
        caption: 'Case Number',
        type: 'text',
        placeholder: 'Enter Case Number',
        class: 'caseNumber',
      },
      {
        name: 'ediId',
        caption: 'Routing ID',
        type: 'text',
        placeholder: 'Enter Routing ID',
        class: 'routingId',
      },
      {
        name: 'enrollmentType',
        caption: 'enrollment type',
        type: 'ngselect',
        bindLabel: 'text',
        bindValue: 'value',
        placeholder: 'Select Enrollment Type',
        multiple: true,
        withCheckbox: true,
        class: 'enrollmentType',
        values: [
          { text: 'ERA', value: 'ERA' },
          { text: 'Institutional', value: 'INSTITUTIONAL' },
          { text: 'Claimstatus', value: 'CLAIMSTATUS' },
          { text: 'Eligibility', value: 'ELIGIBILITY' },
          { text: 'Professional', value: 'PROFESSIONAL' },
        ],
      },
      {
        name: 'showLast',
        caption: 'show last',
        type: 'showlast',
        placeholder: 'Select Date',
        class: 'show',
        values: [30, 60, 90, 120],
      },
      {
        name: 'dateRange',
        type: 'dateRangeCalendarInline',
        dateFromControlName: 'dateFrom',
        dateToControlName: 'dateTo',
        class: 'dates',
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    id: '',
    npi: '',
    taxId: '',
    payerId: '',
    processorId: '',
    ediId: '',
    enrollmentStatus: '',
    dateSetup: 'DESC',
    agreementApprovedDate: '',
    dateLastDbUpdate: '',
    followUpDate: '',
  };

  constructor() {
    super();
    this.init(this._filter, 1, 'dateSetup', 'DESC');
  }

  get groupEnrollments(): IGroupEnrollment[] {
    return this._groupEnrollment;
  }

  set groupEnrollments(value: IGroupEnrollment[]) {
    this._groupEnrollment = value;
  }
}
